<template>
    <div>
    <b-container fluid>
        <!-- Top message row -->
        <b-row style="margin-top:40px; background-color:#2e5189; color:whitesmoke; margin: 0px; padding-top:50px; padding-bottom:50px; padding:50px">
            <b-col>
                <h2>Keg Seeker is an <strong class="breweryname">Online Storefront</strong> for <strong class="breweryname">Crafters and Distributors</strong> to sell online to <strong class="breweryname">Businesses</strong> such as restaurants, bars, pubs, liquor stores</h2>
            </b-col>
        </b-row>


    </b-container>

    <b-container>
        <b-row>
            <b-col>
                <small style="padding-top:50px; padding-bottom:50px; padding:50px">Keg Seeker does not deliver products or collect payments. Use your existing distribution and payment channels.</small>
            </b-col>
        </b-row>

        <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">
        <!-- First row -->
        <b-row style="">
            <b-col md='5' style="margin-left:50px; margin-top:20px; ">
                <table>
                    <tbody>
                        <tr>
                            <td><img width="40px" src="../assets/dollar.png" style="margin-right:20px"/></td>
                            <td>
                                <h5 class="breweryname">SELL KEGS, CANS, BOTTLES</h5>
                                <small>Unlimited products. Choose which states and counties
                                your products are available in. Only buyers in your selected states and counties can order your products. For each product, set up to two different keg sizes, a cans package and a bottles package.
                                Get instant order notifications, communicate with buyers with built in real time chat.</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>

            <b-col style="margin-left:50px; margin-right:50px; margin-top:20px; ">
                <table >
                    <tbody>
                        <tr >
                            <td ><img  width="40px" src="../assets/dollar.png" style="margin-right:20px;"/></td>
                            <td >
                                <h5 class="breweryname">INVENTORY MANAGEMENT</h5>
                                <small>Manage your inventory. Keg Seeker will automatically update your inventory for any products sold 
                                on Keg Seeker. </small>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </b-col>
        </b-row>
        
        <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">

        <!-- Second row -->
        <b-row style="">
            <b-col md='5' style="margin-left:50px; margin-top:20px">
                <table>
                    <tbody>
                        <tr>
                            <td><img width="40px" src="../assets/dollar.png" style="margin-right:20px"/></td>
                            <td>
                                <h5 class="breweryname">MARKETING</h5>
                                <small>Send emails to all buyers on Keg Seeker with your inventory and a direct link to order instantly. Upload your contacts and send your inventory with links to order.</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>

            <b-col style="margin-left:50px; margin-right:50px; margin-top:20px">
                <table>
                    <tbody>
                        <tr>
                            <td><img width="40px" src="../assets/dollar.png" style="margin-right:20px"/></td>
                            <td>
                                <h5 class="breweryname">SALES REPS</h5>
                                <small>Unlimited sales rep accounts. Assign any rep to any county. Reps can accept orders and communciate with buyers.</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
        
        <hr style="height:1px;border-width:0;color:#cccccc;background-color:#cccccc">

        <!-- Third row -->
        <b-row style="">
            <b-col md='5' style="margin-left:50px; margin-top:20px">
                <table>
                    <tbody>
                        <tr>
                            <td><img width="40px" src="../assets/dollar.png" style="margin-right:20px"/></td>
                            <td>
                                <h5 class="breweryname">DISTRIBUTORS</h5>
                                <small>Manage multiple brands. Assign different sales reps for each brand and region if needed.</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>

            <b-col style="margin-left:50px; margin-right:50px; margin-top:20px">
                <table>
                    <tbody>
                        <tr>
                            <td><img width="40px" src="../assets/dollar.png" style="margin-right:20px"/></td>
                            <td>
                                <h5 class="breweryname">SALES REPORTS</h5>
                                <small>Track your sales over time, see who your highest grossing buyers are.</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
        <footer><pagefooter/></footer>

    </b-container>
    
    </div>
</template>

<script>

import { mapState } from 'vuex'
import Pagefooter from './Pagefooter'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Pagefooter,
    },

    data() {
        return {

        }
    },

    methods:{
        pageChanged(){
            window.scrollTo(0,0)
        },
    },

    mounted(){
    },
}
</script>

<style scoped>
.imagecenter {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width:40px;

}
</style>

